/**
 * checkTokenBinding API 响应类型
 */
export interface CheckTokenBindingResponse {
  isBound: boolean;
  boundSpaceId: string | null;
  boundUserId: string | null;
  customerIdentifier: string | null;
  productCode: string | null;
  bindTime: string | null;
  message: string;
  isExpired: boolean;
}

/**
 * Amazon Marketplace Token 管理类
 * 集中管理所有与Amazon Marketplace Token相关的操作
 */
export class AmazonMarketplaceToken {
  private static readonly STORAGE_KEY = 'x-amzn-marketplace-token';
  private static readonly URL_PARAM = 'x-amzn-marketplace-token';

  /**
   * 从URL中提取并保存Amazon Marketplace Token到localStorage
   */
  static saveFromUrl(): void {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get(this.URL_PARAM);

    if (token) {
      // 对token进行URL解码
      const decodedToken = decodeURIComponent(token);
      localStorage.setItem(this.STORAGE_KEY, decodedToken);
      console.log('Amazon Marketplace Token saved to localStorage');
    }
  }

  /**
   * 从localStorage获取Amazon Marketplace Token
   */
  static get(): string | null {
    return localStorage.getItem(this.STORAGE_KEY);
  }

  /**
   * 检查是否存在Amazon Marketplace Token
   */
  static exists(): boolean {
    return !!this.get();
  }

  /**
   * 清理localStorage中的Amazon Marketplace Token
   */
  static clear(): void {
    localStorage.removeItem(this.STORAGE_KEY);
    console.log('Amazon Marketplace Token cleared from localStorage');
  }

  /**
   * 设置Amazon Marketplace Token到localStorage
   * @param token - 要设置的token
   */
  static set(token: string): void {
    localStorage.setItem(this.STORAGE_KEY, token);
  }
}
